import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import LeadForm from './components/LeadForm';
import Footer from './components/Footer';
import { SchemaOrg } from '../../utils/seo';

export default function VideographyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Long Island Video Production | Bellport Branding';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Professional video production services for Long Island businesses. Corporate videos, promotional content, event coverage, real estate videos, and social media content. Expert videography and editing services in Bellport, Patchogue, and throughout Long Island, NY.');
    setMeta('keywords', 'video production Long Island, videography services, corporate video production, promotional videos, event video coverage, real estate video, social media video content, professional video editing, Bellport NY, Patchogue NY');
    setMeta('geo.region', 'US-NY');
    setMeta('geo.placename', 'Bellport');
    setMeta('geo.position', '40.7567;-72.9390');
    setMeta('og:title', 'Long Island Video Production | Bellport Branding', true);
    setMeta('og:description', 'Professional video production services for Long Island businesses. Corporate videos, promotional content, event coverage, real estate videos, and social media content.', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://bellportbranding.com/videography', true);
    setMeta('og:image', 'https://bellportbranding.com/og-videography.jpg', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Long Island Video Production | Bellport Branding');
    setMeta('twitter:description', 'Professional video production services for Long Island businesses. Corporate videos, promotional content, event coverage, and more.');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://bellportbranding.com/videography');
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "VideoObject",
        "name": "Professional Video Production Services Long Island",
        "description": "Expert video production services for Long Island businesses including corporate videos, promotional content, event coverage, real estate videos, and social media content creation.",
        "provider": {
          "@type": "LocalBusiness",
          "name": "Bellport Branding",
          "telephone": "(631) 567-5656",
          "email": "info@bellportbranding.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Bellport",
            "addressRegion": "NY",
            "addressCountry": "US"
          }
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is the typical turnaround time for a video project?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Most projects are completed within 2-4 weeks, depending on complexity. Rush services are available for urgent needs."
            }
          },
          {
            "@type": "Question",
            "name": "Do you offer video production packages?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes! We offer customized packages for corporate videos, events, real estate, and social media content. Contact us for a personalized quote."
            }
          }
        ]
      }
    ]
  };

  return (
    <>
      <SchemaOrg type="Service" data={structuredData} />
      <div className="min-h-screen bg-white">
        <Navbar />
        <Hero />
        <Services />
        <Process />
        <Testimonials />
        <FAQ />
        <LeadForm />
        <Footer />
      </div>
    </>
  );
}
